import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import DropDownSelect from '../DropDownSelect/index'
import { sectionTemplateConfig, sectionTemplateType } from '../action';
import { keysDropdownConfig } from './helper';
class SectionTemplateForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            keys: null,
            sectionTemplateType: null,
            validationError: null,
            disable: false,
            disableSection: false,
            keysData: []
        }
        // const labelWithIcon = <span className="fas fa-stroopwafel" />
    }

    componentDidMount() {
        this.props.sectionTemplateConfig();
        this.props.sectionTemplateType()
    }
    componentDidUpdate(prevProps) {
        if (this.props.sectionTemplateFormValues.values &&
            this.props.sectionTemplateFormValues !== prevProps.sectionTemplateFormValues) {
            if (this.props.sectionTemplateFormValues.values.sectionType === 'PREDEFINED' || this.props.sectionTemplateFormValues.values.sectionType === 'INTERNATIONAL') {
                this.setState({
                    disable: true
                })
                this.props.change('keys', "NONE")//FINANCIAL
            } else if (this.props.sectionTemplateFormValues.values.sectionType === 'FINANCIAL') {
                this.setState({
                    disable: true,
                    keysData: this.props.configList
                }, () => {
                    this.props.change('keys', "VERTICAL_KEY_VALUE")//FINANCIAL
                })

            } else if (this.props.sectionTemplateFormValues.values.sectionType !== 'FINANCIAL') {
                const tempData = keysDropdownConfig(this.props.configList)
                this.setState({
                    keysData: tempData,
                    disable: false
                })
            } else {
                this.setState({
                    disable: false
                })
            }
        }
        if (this.props.configList !== prevProps.configList) {
            this.setState({
                keysData: this.props.configList
            })
        }
    }

    onKeyTypeChange = (keyTypeValue) => {
        this.props.change('keys', keyTypeValue);
    }
    render() {
        return (
            <form autoComplete="on">
                <div className="row form-group">
                    <div className="col-md-5 col-sm-5 col-lg-5">
                        <label>Template Name</label>
                    </div>
                    <div className="col-md-10 col-lg-10 col-sm-10">
                        <Field type="text"
                            className="form-control"
                            component="input"
                            name="sectionTemplateName"
                            id="sectionTemplateName"
                            validate={[required]}
                            placeholder="Name of Section Template"
                        />
                    </div>
                </div>
                <Row className="form-group">
                    <Col sm="5">
                        <label>Display Name for Report</label>
                    </Col>
                    <Col sm="10">
                        <Field type="text"
                            className="form-control"
                            component="input"
                            name="reportDisplayName"
                            id="reportDisplayName"
                            validate={[required]}
                            placeholder="Name to display in report header"
                        />
                    </Col>
                </Row>
                <Row className="form-group">
                    <Col sm="5">
                        <label>Tags</label>
                    </Col>
                    <Col sm="10">
                        <Field type="text"
                            className="form-control"
                            component="input"
                            name="tags"
                            id="tags"
                            placeholder="Tags"
                        />
                    </Col>
                </Row>
                <div className="row form-group">
                    <div className="col-md-5 col-sm-5 col-lg-5">
                        <label>Section Type</label>
                    </div>
                    <div className="col-md-10 col-lg-10 col-sm-10">
                        <Field
                            name="sectionType"
                            // component="select"
                            label="dropDownSelect"
                            component={DropDownSelect}
                            validate={[required]}
                            className="form-control"
                            data={this.props.sectionTypeList}
                            dis={this.state.disableSection}
                        >
                        </Field>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-5 col-sm-5 col-lg-5">
                        <label>Key Types</label>
                    </div>
                    <div className="col-md-10 col-lg-10 col-sm-10">
                        <Field
                            name="keys"
                            // component="select"
                            label="dropDownSelect"
                            component={DropDownSelect}
                            validate={[required]}
                            className="form-control"
                            data={this.state.keysData}
                            dis={this.state.disable}
                        >
                        </Field>
                    </div>
                </div>
                 <div className="row form-group">
                     <div className="col-md-5 col-sm-5 col-lg-5">
                        <label> Analyst Visible ?</label>
                    </div>
                    <div className="col-md-10 col-lg-10 col-sm-10">
                       &nbsp;&nbsp; <Field name="analystVisible" component="input" type="checkbox" />
                    </div>
                </div>

               { this.props.pageType === "Edit" && <Row className="form-group">
                    <Col sm="5">
                        <label>Display Name for API</label>
                    </Col>
                    <Col sm="10">
                        <Field type="text"
                            className="form-control"
                            component="input"
                            name="apiKeyName"
                            id="apiKeyName"
                            placeholder="Name to display in API"
                        />
                    </Col>
                </Row>}
            </form>
        )
    }
}

const required = value => value ? undefined : 'Required';
SectionTemplateForm = reduxForm({
    form: 'sectionTemplate',
    enableReinitialize: true
})(SectionTemplateForm)

const mapStateToProps = (state, ownProps) => ({
    sectionTemplateFormValues: state.form.sectionTemplate,
    configList: state.sectionTemplate.sectionTemplateconfig,
    sectionTypeList: state.sectionTemplate.sectionTypeList
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    sectionTemplateConfig: () => { dispatch(sectionTemplateConfig()) },
    sectionTemplateType: () => { dispatch(sectionTemplateType()) }
});
export default SectionTemplateForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(SectionTemplateForm)
